import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Oferta from '../../components/Oferta'
import * as ofertaActions from '../../reducers/OfertaReducer/actions'
import { usuarioSelector } from '../../selectors/sessionSelector'
import { ofertaSelector } from '../../selectors/ofertaSelector'


class OfertaContainer extends React.Component {

    constructor(props) {
        super(props)

        const oOfertaSelected = JSON.parse(localStorage.getItem('idOfertaSelected'));
        let ofertaSelected = oOfertaSelected ? oOfertaSelected.idOfertaSelected : (this.props.dataContenido.ofertas && this.props.dataContenido.ofertaSelected ? this.props.dataContenido.ofertaSelected : undefined);

        this.state = {
            ofertaSelected: ofertaSelected,//this.props.dataContenido.tiposContenido && this.props.dataContenido.tipoContenidoSelected ? this.props.dataContenido.tipoContenidoSelected : tipoContenidoSelected,
            ofertaSelectedImg: ofertaSelected ? ofertaSelected : 1,
            usuarioCargado: false,
            ofertasCargadas: false,
            openModalVer: false,
            itemSelectedVer: undefined,
            itemSelectedEditar: undefined,
            itemABorrar: undefined,
            openModalBorrar: false,
            itemOfertaSelected: ofertaSelected,
            openModalConfirm: false
        }
        this.props.sagaGetOfertas()
    }

    componentDidUpdate = () => {
        if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
            this.setState({ usuarioCargado: true }, () => {
                if (this.props.usuario.idRol === 4) {
                    window.location.hash = '/Pedidos'
                }
            })
        }

        if (this.state.ofertasCargadas === false && this.props.dataContenido.ofertas !== undefined) {
            const oOfertaSelected = JSON.parse(localStorage.getItem('idOfertaSelected'));

            let ofertaSelected = oOfertaSelected ? oOfertaSelected.idOfertaSelected : this.props.dataContenido.ofertas[0].idOferta
            let itemOfertaSelected = this.props.dataContenido.ofertas[0]

            this.setState({ ofertasCargadas: true, ofertaSelected: ofertaSelected, itemOfertaSelected: itemOfertaSelected }, () => {
                //buscar oferta   
                /*                             
                this.props.setOfertaSelected(ofertaSelected)
                this.props.sagaGetOfertas(ofertaSelected)
                */
            })
        }
    }

    componentDidMount = () => {
        window.onbeforeunload = function (e) {
            localStorage.removeItem('idOfertaSelected');
            return undefined;
        };
    }

    handleOnClickVer = (item) => {
        this.setState({ openModalVer: item === undefined ? false : true, itemSelectedVer: item })
    }

    handleOnClickBorrar = (item, confirma) => {
        if (confirma === false) {
            if (item === undefined) {
                return
            }

            this.setState({ itemABorrar: item, openModalBorrar: true })
        }
        else {
            let oferta = this.state.itemABorrar
            if (oferta === undefined) {
                return
            }

            this.setState({ itemABorrar: undefined, openModalBorrar: false }, () => {
                this.props.sagaBorrarOferta(oferta.idOferta)
            })
        }
    }

    handleOnClickCerrarModal = () => {
        this.setState({ openModalBorrar: false, openModalVer: false })
    }

    handleOnSwap = (ids) => {
        let payload = {
            ids: ids
        }

        this.props.sagaSwapOferta(payload)
    }

    render() {
        return (
            <Oferta
                mapToItem={(x) => ({
                    nombreOferta: x.nombreOferta,
                    opciones:
                        [
                            (x.activo) ? { nombre: "Ver Detalle", handler: () => { this.props.history.push("/Oferta/Editar/" + x.id) } } : undefined,
                            (x.activo) ? {
                                nombre: "Borrar", handler: () => {
                                    this.setState({
                                        openModalConfirm: true, botonOk: "Borrar",
                                        mensajeConfirmacion: `Estás por borrar la oferta ${x.nombre}`,
                                        handleOk: () => { this.props.sagaBorrarOferta(x.id); }
                                    })
                                }
                            } : undefined,
                        ],
                })}
                {...this.state}
                today={new Date()}
                ofertaSelectedImg={this.state.ofertaSelectedImg}
                ofertaSelected={this.state.ofertaSelected}
                tiposContenido={this.props.dataContenido.tiposContenido}
                itemOfertaSelected={this.state.itemOfertaSelected}
                ofertas={this.props.dataContenido.ofertas}
                openModalVer={this.state.openModalVer}
                openModalBorrar={this.state.openModalBorrar}
                handleOnClickVer={this.handleOnClickVer}
                handleOnClickEditar={this.handleOnClickEditar}
                handleOnClickBorrar={this.handleOnClickBorrar}
                handleOnClickCerrarModal={this.handleOnClickCerrarModal}
                handleOnSwap={this.handleOnSwap}
                itemABorrar={this.state.itemABorrar}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ...ofertaActions
    }, dispatch)
}

function mapStateToProps(state) {
    return {
        usuario: usuarioSelector(state),
        dataContenido: ofertaSelector(state)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OfertaContainer)